import api from '../api/client';
import React from "react";
import { Modal, Descriptions, Tag, Typography, Divider, Space } from "antd";
import { BankOutlined, MobileOutlined } from "@ant-design/icons";
import { FaCashRegister } from "react-icons/fa";

const { Text } = Typography;

const EmployeeViewModal = ({ employee, users, visible, onClose }) => {
  if (!employee) return null;

  const user = users.find((u) => u.id === employee.user_id);
  const employeeName = user ? `${user.firstname} ${user.lastname}` : "Unknown Employee";

  const formatCurrency = (amount) => {
    return amount?.toLocaleString("en-US", {
      minimumFractionDigits: 2,
    }) || "-";
  };

  const getPaymentMethodIcon = () => {
    switch (employee.payment_method) {
      case "Bank":
        return <BankOutlined style={{ color: "#1677ff" }} />;
      case "Mpesa":
        return <MobileOutlined style={{ color: "#52c41a" }} />;
      case "Cash":
        return <FaCashRegister style={{ color: "#faad14" }} />;
      default:
        return null;
    }
  };

  const getPaymentMethodDetails = () => {
    switch (employee.payment_method) {
      case "Bank":
        return `${employee.bank_name} - ${employee.bank_account} (${employee.account_type})`;
      case "Mpesa":
        const userPhone = user?.phone_number || "N/A";
        return `Mpesa (${userPhone})`;
      case "Cash":
        return "Cash Payment";
      default:
        return "N/A";
    }
  };

  return (
    <Modal
      title={
        <Space>
          {getPaymentMethodIcon()}
          <span>Employee Details: {employeeName}</span>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      width={700}
      footer={null}
    >
      <Descriptions title="Personal Information" bordered column={2} size="small">
        <Descriptions.Item label="Name" span={2}>
          {employeeName}
        </Descriptions.Item>
        {employee.kra_pin && (
          <Descriptions.Item label="KRA PIN">{employee.kra_pin}</Descriptions.Item>
        )}
        {employee.nssf_number && (
          <Descriptions.Item label="NSSF Number">{employee.nssf_number}</Descriptions.Item>
        )}
        {employee.nhif_number && (
          <Descriptions.Item label="NHIF Number">{employee.nhif_number}</Descriptions.Item>
        )}
      </Descriptions>

      <Descriptions title="Salary Information" bordered column={2} size="small" style={{ marginTop: 16 }}>
        <Descriptions.Item label="Base Salary">
          <Text strong style={{ color: "#52c41a" }}>
            KES {formatCurrency(employee.base_salary)}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Payment Method">
          <Tag color={employee.payment_method === "Bank" ? "blue" : employee.payment_method === "Mpesa" ? "green" : "orange"}>
            {employee.payment_method}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Account Details" span={2}>
          {getPaymentMethodDetails()}
        </Descriptions.Item>
        {employee.bank_name && (
          <Descriptions.Item label="Bank">{employee.bank_name}</Descriptions.Item>
        )}
        {employee.bank_account && (
          <Descriptions.Item label="Bank Account">{employee.bank_account}</Descriptions.Item>
        )}
        {employee.account_type && (
          <Descriptions.Item label="Account Type">{employee.account_type}</Descriptions.Item>
        )}
        {employee.branch_name && (
          <Descriptions.Item label="Branch">
            {employee.branch_name} ({employee.branch_code})
          </Descriptions.Item>
        )}
      </Descriptions>

      {employee.notes && (
        <>
          <Divider />
          <div>
            <Text strong>Additional Notes</Text>
            <div
              style={{
                padding: 12,
                backgroundColor: "#f5f5f5",
                borderRadius: 8,
                marginTop: 8,
              }}
            >
              {employee.notes}
            </div>
          </div>
        </>
      )}

      <Divider />
      <Text type="secondary" style={{ fontSize: 12 }}>
        Last updated: {new Date(employee.updatedAt || employee.createdAt).toLocaleString()}
      </Text>
    </Modal>
  );
};

export default EmployeeViewModal;